import * as React from "react";

import { PlpSelectedFacetOption } from "../model";

import {
  usePlpPresenterForTheFilterMenu_AnyBreakpoint,
  useProductListState,
} from "../providers";

import { SelectedOption } from "../selected-option";

export const MobileAppliedFilters: React.FunctionComponent = () => {
  const { selectedOptions } = useProductListState();

  const { handleRemoveSelectedFilterOption, handleRemoveAllSelectedOptions } =
    usePlpPresenterForTheFilterMenu_AnyBreakpoint();

  if (selectedOptions.length < 1) {
    return null;
  }

  const handleAction = (
    event: React.MouseEvent,
    selectedOption: PlpSelectedFacetOption
  ) => {
    event.stopPropagation();
    event.preventDefault();

    handleRemoveSelectedFilterOption(selectedOption);
  };

  const onClearAll = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    handleRemoveAllSelectedOptions();
  };

  return (
    <div aria-label="selected options" className="mobile-applied-filters">
      {selectedOptions.map((selectedOption) => (
        <SelectedOption selectedOption={selectedOption} action={handleAction} />
      ))}
      <button className="clear-all" onClick={onClearAll}>
        Clear All
      </button>
    </div>
  );
};
